<template>
    <div class="modal fade custom-right-modal" id="quotationMessageModal" ref="quotationMessageModal">
        <div class="modal-dialog" style="max-width: 1140px !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Messages</h4>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
                        <li class="nav-item" :class="{'active': tab == 1}">
                            <a class="nav-link customer_messages" id="one-tab" data-toggle="tab" href="#one" ref="customerMessagesRef"
                               @click="changeTab(1)" role="tab" aria-controls="One" aria-selected="true">Customer
                                Messages</a>
                        </li>
                        <li class="nav-item" :class="{'active': tab == 2}">
                            <a class="nav-link vendor_messages1" id="two-tab" data-toggle="tab" href="#two"
                               @click="changeTab(2)" role="tab" aria-controls="Two" aria-selected="false">Vendor Messages</a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade p-3" :class="{'in active': tab == 1}" id="one" role="tabpanel" aria-labelledby="one-tab">
                            <template v-if="customer && customer.data.length >0">
                                <Inbox :type="'customer'" :messages="customer.data" :selected="customer.data.length ? customer.data[0] : null" :quotation="quotation"></Inbox>

                            </template>
                            <span class="main_ven" v-if="customer.data.length == 0">
                                <div class="message_area"><center>No Mail Found</center></div>
                            </span>

                            <!--<div class="customer_message_area messages_List" v-if="customer">
                                <template v-if="customer.system_messages_quote.length == 0 && customer.system_messages.length == 0 && customer.system_messages_send.length == 0 && customer.messages.length == 0">
                                    <div class="message_area"><center>No Mail Found</center></div>
                                </template>
                                <template v-else>
                                    <template v-for="(messageItem, index) in customer.messages">
                                        <div class="messgaes_Container">
                                            <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                 data-toggle="collapse"
                                                 :href="'#customerMsg' + messageItem.mail_id"
                                                 aria-expanded="false"
                                                 :aria-controls="'#customerMsg' + messageItem.mail_id">
                                                <div class="img_container">
                                                    <div class="image">{{messageItem.name.charAt(0)}}</div>
                                                </div>
                                                <div class="ms_text">
                                                    <h4>{{ messageItem.name.charAt(0).toUpperCase() }} {{messageItem.name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                    <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                    <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                </div>
                                            </div>
                                            <div  class="message_Details collapse" :id="'customerMsg' + messageItem.mail_id">
                                                <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                        class="btngo_Back"
                                                        data-toggle="collapse"
                                                        :href="'#customerMsg' + messageItem.mail_id"
                                                        role="button"
                                                        aria-expanded="false"
                                                        :aria-controls="'#customerMsg' + messageItem.mail_id">
                                                    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                        <g id="Group_1" data-name="Group 1">
                                                            <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                <div class="mds_header">
                                                    <div class="image_container">
                                                        <div class="image">{{messageItem.name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="text">
                                                        <h4>{{messageItem.name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                        <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                <div class="message_inner">{{messageItem.message_body}}</div>
                                                <div class="attachment_file">
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-for="(messageItem, index) in customer.system_messages">
                                        <div class="messgaes_Container">
                                            <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                 data-toggle="collapse"
                                                 :href="'#customerSystemMsg' + messageItem.mail_id"
                                                 aria-expanded="false"
                                                 :aria-controls="'#customerSystemMsg' + messageItem.mail_id">
                                                <div class="img_container">
                                                    <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                </div>
                                                <div class="ms_text">
                                                    <h4>{{ messageItem.contact_name.charAt(0).toUpperCase() }} {{messageItem.contact_name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                    <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                    <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                </div>
                                            </div>
                                            <div  class="message_Details collapse" :id="'customerSystemMsg' + messageItem.mail_id">
                                                <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                        class="btngo_Back"
                                                        data-toggle="collapse"
                                                        :href="'#customerSystemMsg' + messageItem.mail_id"
                                                        role="button"
                                                        aria-expanded="false"
                                                        :aria-controls="'#customerSystemMsg' + messageItem.mail_id">
                                                    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                        <g id="Group_1" data-name="Group 1">
                                                            <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                <div class="mds_header">
                                                    <div class="image_container">
                                                        <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="text">
                                                        <h4>{{messageItem.contact_name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                        <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="message_inner">{{messageItem.message_body}}</div>
                                                <div class="attachment_file">
                                                    <template v-for="(attachment) in messageItem.attachments">
                                                        <img :src="'/message_files/'+attachment.file_name" width="180px" height="120px">
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-for="(messageItem, index) in customer.system_messages_quote">
                                        <div class="messgaes_Container">
                                            <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                 data-toggle="collapse"
                                                 :href="'#customerSystemMsgQuote' + messageItem.mail_id"
                                                 aria-expanded="false"
                                                 :aria-controls="'#customerSystemMsgQuote' + messageItem.mail_id">
                                                <div class="img_container">
                                                    <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                </div>
                                                <div class="ms_text">
                                                    <h4>{{ messageItem.contact_name.charAt(0).toUpperCase() }} {{messageItem.contact_name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                    <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                    <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                </div>
                                            </div>
                                            <div  class="message_Details collapse" :id="'customerSystemMsgQuote' + messageItem.mail_id">
                                                <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                        class="btngo_Back"
                                                        data-toggle="collapse"
                                                        :href="'#customerSystemMsgQuote' + messageItem.mail_id"
                                                        role="button"
                                                        aria-expanded="false"
                                                        :aria-controls="'#customerSystemMsgQuote' + messageItem.mail_id">
                                                    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                        <g id="Group_1" data-name="Group 1">
                                                            <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                <div class="mds_header">
                                                    <div class="image_container">
                                                        <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="text">
                                                        <h4>{{messageItem.contact_name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                        <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="message_inner">{{messageItem.message_body}}</div>
                                                <div class="attachment_file">
                                                    <template v-for="(attachment) in messageItem.attachments">
                                                        <img :src="'/message_files/'+attachment.file_name" width="180px" height="120px">
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-for="(messageItem, index) in customer.system_messages_send">
                                        <div class="messgaes_Container">
                                            <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                 data-toggle="collapse"
                                                 :href="'#customerSystemMsgSend' + messageItem.mail_id"
                                                 aria-expanded="false"
                                                 :aria-controls="'#customerSystemMsgSend' + messageItem.mail_id">
                                                <div class="img_container">
                                                    <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                </div>
                                                <div class="ms_text">
                                                    <h4>{{ messageItem.contact_name.charAt(0).toUpperCase() }} {{messageItem.contact_name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                    <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                    <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                </div>
                                            </div>
                                            <div  class="message_Details collapse" :id="'customerSystemMsgSend' + messageItem.mail_id">
                                                <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                        class="btngo_Back"
                                                        data-toggle="collapse"
                                                        :href="'#customerSystemMsgSend' + messageItem.mail_id"
                                                        role="button"
                                                        aria-expanded="false"
                                                        :aria-controls="'#customerSystemMsgSend' + messageItem.mail_id">
                                                    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                        <g id="Group_1" data-name="Group 1">
                                                            <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                <div class="mds_header">
                                                    <div class="image_container">
                                                        <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="text">
                                                        <h4>{{messageItem.contact_name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                        <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="message_inner">{{messageItem.message_body}}</div>
                                                <div class="attachment_file">
                                                    <template v-for="(attachment) in messageItem.attachments">
                                                        <img :src="'/message_files/'+attachment.file_name" width="180px" height="120px">
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>

                            </div>
                            <div class="row chat-blk fixed"></div>
                            <div class="row chat-blk fixed">
                                <div class="rply_text_div">
                                    <a v-if="!prevVersionMailData.isPrevMail" href="javascript:void(0)"  @click="openReplyModal('customer')"
                                       class="openMailReplyModal">
                                        Click here to reply
                                    </a>
                                </div>
                            </div>-->
                        </div>

                        <div class="tab-pane fade p-3" :class="{'in active': tab == 2}" id="two" role="tabpanel" aria-labelledby="two-tab">
                            <div class="user-icon-sec" v-if="vendor_mails.length > 0">
                                <Inbox :type="'vendor'" :messages="vendor_mails" :selected="vendor_mails[0]" :quotation="quotation"></Inbox>
                                <!--<template v-for="(item, index) in vendor_mails">
                                    <div class="user-icon-block" :class="{'active': index === selectedVendorIndex}"
                                         @click="vendor_messages(item, index)">
                                        <div class="user-img">
                                            <img :src="asset('admin/images/vendor_image.png')" alt="client" />
                                        </div>
                                        <div v-if="item.company_name" class="small-heading">{{item.contact_name}} ({{item.company_name}})</div>
                                        <div v-else class="small-heading">{{item.contact_name}}</div>
                                    </div>
                                </template>-->
                                <!--<template v-if="vendorMailData && vendorMailData.success">
                                    <div class="message_area messages_List">
                                        <template v-for="(messageItem, index) in vendorMailData.messages">
                                            <div class="messgaes_Container">
                                                <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                     data-toggle="collapse"
                                                     :href="'#vendorMsg' + messageItem.mail_id"
                                                     aria-expanded="false"
                                                     :aria-controls="'#vendorMsg' + messageItem.mail_id">
                                                    <div class="img_container">
                                                        <div class="image">{{messageItem.name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="ms_text">
                                                        <h4>{{ messageItem.name.charAt(0).toUpperCase() }} {{messageItem.name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                        <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                        <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                    </div>
                                                </div>
                                                <div  class="message_Details collapse" :id="'vendorMsg' + messageItem.mail_id">
                                                    <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                            class="btngo_Back"
                                                            data-toggle="collapse"
                                                            :href="'#vendorMsg' + messageItem.mail_id"
                                                            role="button"
                                                            aria-expanded="false"
                                                            :aria-controls="'#vendorMsg' + messageItem.mail_id">
                                                        <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                            <g id="Group_1" data-name="Group 1">
                                                                <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                    <div class="mds_header">
                                                        <div class="image_container">
                                                            <div class="image">{{messageItem.name.charAt(0)}}</div>
                                                        </div>
                                                        <div class="text">
                                                            <h4>{{messageItem.name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                            <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="message_inner">{{messageItem.message_body}}</div>
                                                    <div class="attachment_file">
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-for="(messageItem, index) in vendorMailData.system_messages">
                                            <div class="messgaes_Container">
                                                <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                     data-toggle="collapse"
                                                     :href="'#vendorSystemMsg' + messageItem.mail_id"
                                                     aria-expanded="false"
                                                     :aria-controls="'#vendorSystemMsg' + messageItem.mail_id">
                                                    <div class="img_container">
                                                        <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="ms_text">
                                                        <h4>{{ messageItem.contact_name.charAt(0).toUpperCase() }} {{messageItem.contact_name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                        <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                        <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                    </div>
                                                </div>
                                                <div  class="message_Details collapse" :id="'vendorSystemMsg' + messageItem.mail_id">
                                                    <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                            class="btngo_Back"
                                                            data-toggle="collapse"
                                                            :href="'#vendorSystemMsg' + messageItem.mail_id"
                                                            role="button"
                                                            aria-expanded="false"
                                                            :aria-controls="'#vendorSystemMsg' + messageItem.mail_id">
                                                        <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                            <g id="Group_1" data-name="Group 1">
                                                                <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                    <div class="mds_header">
                                                        <div class="image_container">
                                                            <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                        </div>
                                                        <div class="text">
                                                            <h4>{{messageItem.contact_name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                            <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="message_inner">{{messageItem.message_body}}</div>
                                                    <div class="attachment_file">
                                                        <template v-for="(attachment) in messageItem.attachments">
                                                            <img :src="'/message_files/'+attachment.file_name" width="180px" height="120px">
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-for="(messageItem, index) in vendorMailData.system_messages_sent">
                                            <div class="messgaes_Container">
                                                <div class="mlist_Item" @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                     data-toggle="collapse"
                                                     :href="'#vendorSystemSent' + messageItem.mail_id"
                                                     aria-expanded="false"
                                                     :aria-controls="'#vendorSystemSent' + messageItem.mail_id">
                                                    <div class="img_container">
                                                        <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                    </div>
                                                    <div class="ms_text">
                                                        <h4>{{ messageItem.contact_name.charAt(0).toUpperCase() }} {{messageItem.contact_name.slice(1)}} <span>{{messageItem.created_at}}</span></h4>
                                                        <div class="ms_subject">{{messageItem.quote_subject}}</div>
                                                        <div class="ms_Description">{{trimmedMsgBody(messageItem.message_body)}}</div>
                                                    </div>
                                                </div>
                                                <div  class="message_Details collapse" :id="'vendorSystemSent' + messageItem.mail_id">
                                                    <button @click="selectCustomerMessage(messageItem.mail_id, index)"
                                                            class="btngo_Back"
                                                            data-toggle="collapse"
                                                            :href="'#vendorSystemSent' + messageItem.mail_id"
                                                            role="button"
                                                            aria-expanded="false"
                                                            :aria-controls="'#vendorSystemSent' + messageItem.mail_id">
                                                        <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 248">
                                                            <g id="Group_1" data-name="Group 1">
                                                                <path id="Path_1" data-name="Path 1" d="M5.866,241.843c.006-.006.011-.013.018-.019l104.5-104a20,20,0,0,1,28.218,28.352L68.442,236H492a20,20,0,0,1,0,40H68.443l70.162,69.824a20,20,0,0,1-28.218,28.352l-104.5-104c-.006-.006-.011-.013-.018-.019A20.017,20.017,0,0,1,5.866,241.843Z" transform="translate(0 -132)" fill="#fff"/>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <div class="mds_top">{{messageItem.quote_subject}}</div>
                                                    <div class="mds_header">
                                                        <div class="image_container">
                                                            <div class="image">{{messageItem.contact_name.charAt(0)}}</div>
                                                        </div>
                                                        <div class="text">
                                                            <h4>{{messageItem.contact_name}}<span class="time">{{messageItem.created_at}}</span></h4>
                                                            <div class="mdsheader_bottom"><p>{{messageItem.email}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="message_inner">{{messageItem.message_body}}</div>
                                                    <div class="attachment_file">
                                                        <template v-for="(attachment) in messageItem.attachments">
                                                            <img :src="'/message_files/'+attachment.file_name" width="180px" height="120px">
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="rply_text_div">
                                        <a v-if="!prevVersionMailData.isPrevMail" href="javascript:void(0)" @click="openReplyModal('vendor')"
                                           class="openMailReplyModal">
                                            Click here to reply
                                        </a>
                                    </div>
                                </template>-->
                            </div>
                            <span class="main_ven" v-if="vendor_mails.length == 0">
                                <div class="message_area"><center>No Mail Found</center></div>
                            </span>
                        </div>

                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">

                </div>

            </div>
        </div>
        <QuoteMessageReplyModal :customer="customer" :vendor="vendor_mails" :quotation="quotation" :userType="replyModalData.userType"
                                :prevVersionMailData="prevVersionMailData"
                                @replyEmailSentEvent="replyEmailSentEvent"></QuoteMessageReplyModal>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import QuoteMessageReplyModal from "./QuoteMessageReplyModal";
import Inbox from "./Inbox";
import InboxDetail from "./InboxDetail";
import InboxCompose from "./InboxCompose";

export default {
    name: "QuotationMessageModal",
    props: ['quotation', 'prevVersionMailData'],
    components: {QuoteMessageReplyModal, Inbox, InboxDetail, InboxCompose},
    created() {
    },
    mounted() {
        let self = this;
        $(this.$refs.quotationMessageModal).on('show.bs.modal', () => {
            self.$refs.customerMessagesRef.click();
            //this.getCustomerMail();
            //this.getVendorMail();
        });
    },
    data() {
        return {
            tab: 1,
            customer: {
                success: null,
                //messages: [],
                //system_messages: [],
                //system_messages_quote: [],
                //system_messages_send: [],
                errorMessage: null,
                data: [],
                errors: []
            },
            vendor_mails: [],
            vendorMailData: null,
            selectedVendorIndex: 0,

            replyModalData: {
                userType: null
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        changeTab(tab) {
            if(tab == 1) {
                this.getCustomerMail();
            } else {
                this.getVendorMail();
            }
            this.tab = tab;
        },
        replyEmailSentEvent(event){
            if(this.replyModalData.userType == 'vendor') {
                this.getVendorMail();
            } else {
                this.getCustomerMail();
            }
        },
        openReplyModal(userType){
            this.replyModalData.userType = userType;
            $("#replyModal").modal('show');
        },
        selectCustomerMessage(mail_id, index) {

        },
        trimmedMsgBody(msg){
            let length = 30;
            msg = $("<div>").html(msg).text()
            return  msg.length > length ? msg.substring(0, length) + "..." : msg;
        },
        getCustomerMail(prev_mail = 0) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('get_customer_messages');

            let payload = {
                quote_id: this.quotation.id,
                customer_id: this.quotation.customer_id,
                contact_id: this.quotation.contact_id,
                prev_mail: prev_mail
            };

            if(this.prevVersionMailData && this.prevVersionMailData.isPrevMail &&
                this.prevVersionMailData.id &&
                this.prevVersionMailData.customer_id &&
                this.prevVersionMailData.contact_id) {
                payload = {
                    quote_id: this.prevVersionMailData.id,
                    customer_id: this.prevVersionMailData.customer_id,
                    contact_id: this.prevVersionMailData.contact_id,
                    prev_mail: this.prevVersionMailData.isPrevMail
                };
            }

            return axios.post(apiUrl, payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.customer = data;
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getVendorMail() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('get_vends');

            let payload = {quote_id: this.quotation.id};

            if(this.prevVersionMailData && this.prevVersionMailData.isPrevMail &&
                this.prevVersionMailData.id &&
                this.prevVersionMailData.customer_id &&
                this.prevVersionMailData.contact_id) {
                payload = {
                    quote_id: this.prevVersionMailData.id
                };
            }

            return axios.post(apiUrl, payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.vendor_mails = data.data;
                        if(this.vendor_mails.length) {
                            this.vendor_messages(this.vendor_mails[0], 0);
                        }
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        vendor_messages(item, index){
            this.selectedVendorIndex = index;
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('get_vendor_messages');

            return axios.post(apiUrl, {quote_id: this.quotation.id, vendor_id: item.vendor_id, contact_id: item.contact_id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.vendorMailData = data;
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
